/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    /* JS FOR PRODUCT IMAGE SLIDER */

document.addEventListener("DOMContentLoaded", function () {
  // Only run on mobile
  if (window.innerWidth > 768) return;

  const sliderWrapper = document.querySelector('product-images.product__images--mobile-slider');
  if (!sliderWrapper) return;

  const scrollContainer = sliderWrapper.querySelector('.product__slides');
  if (!scrollContainer) return;

  // Inject progress bar if it doesn't exist
  if (!sliderWrapper.nextElementSibling?.classList?.contains('mobile-slider-progress')) {
    const progressBarWrapper = document.createElement('div');
    progressBarWrapper.className = 'mobile-slider-progress';
    progressBarWrapper.innerHTML = '<div class="mobile-slider-progress__bar"></div>';
    sliderWrapper.insertAdjacentElement('afterend', progressBarWrapper);
  }

  const progressBar = document.querySelector('.mobile-slider-progress__bar');

  function updateProgressBar() {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const percent = (scrollLeft / maxScroll) * 100;
    progressBar.style.width = `${percent}%`;
  }

  scrollContainer.addEventListener('scroll', updateProgressBar, { passive: true });
  updateProgressBar();
});

document.addEventListener('DOMContentLoaded', function() {
  function updateClocks() {
    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

    const nyElement = document.getElementById('time-ny');
    const lonElement = document.getElementById('time-lon');
    const sydElement = document.getElementById('time-syd');

    if (nyElement) {
      nyElement.textContent = new Date().toLocaleTimeString('en-US', { ...options, timeZone: 'America/New_York' });
    }
    if (lonElement) {
      lonElement.textContent = new Date().toLocaleTimeString('en-GB', { ...options, timeZone: 'Europe/London' });
    }
    if (sydElement) {
      sydElement.textContent = new Date().toLocaleTimeString('en-AU', { ...options, timeZone: 'Australia/Sydney' });
    }
  }

  setInterval(updateClocks, 1000);
  updateClocks();
});




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
